import { View, ViewModel } from "binder"
import { FormBuilderPartViewModel } from "./formBuilderPart-viewModel"

export class FormBuilderPartView extends View<FormBuilderPartViewModel>{
    GetViewUniqueId(): string {
        return "V-FFAE3468-0E0F-4229-9C93-C921B0378B47"
    }
    loadHtml(): string {
        let element = require('./formBuilderPart.html').default;
        let style = require('./formBuilderPart.less');
        return element;
    }
    constructor() {
       super();
    }

    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set content(v: ViewModel) { this._content = v; } public get content(): ViewModel { return this._content;} private _content: ViewModel;

}
